<template>
    <div class="action-item" @click="$store.state.core.featuresStatus.text_magnify = !$store.state.core.featuresStatus.text_magnify" :class="{active: $store.state.core.featuresStatus.text_magnify}">
        <div class="active-action item" v-if="$store.state.core.featuresStatus.text_magnify">
          <span class="icon-check"></span>
        </div>

        <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                >
                  <div v-html="icons.textMagnify"></div>
                  <h3>{{$t('text guide')}}</h3>
                </div>
            </template>
            <span>{{$t('Click on specific text to display it more clearly')}}</span>
        </v-tooltip>
    </div>
</template>


<script>
    import {icons} from '../../utils/icons'
    import tippy from 'tippy.js';
    export default {
        name: "tool-tip-element",
        data() {
            return {
                active: false,
                icons
            }
        },
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            }
        },
        mounted() {
            document.addEventListener('click', e=> {
                if (this.$store.state.core.featuresStatus.text_magnify) {
                    e = e || window.event;
                    let target = e.target || e.srcElement
                    let text = ''
                    if (target.text || target.innerText) {
                        text = target.text || target.innerText
                        const inst = tippy(target)
                        inst.setContent(`<h3 class="white--text">${text}</h3>`)
                        inst.show()
                    }
                }
            }, false);
        },
        watch: {
            '$store.state.core.featuresStatus.text_magnify':function (state) {
              localStorage.setItem('featuresStatus', JSON.stringify(this.$store.state.core.featuresStatus))
                if (state) {
                    this.$emit('countAnalytics', this.data._id)
                }
            }
        }
    }
</script>

<style>
.white--text {
    color: white !important;
}
</style>
